import type { Device, DeviceItemResponse } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

const useDeviceById = (id?: string, enabled?: boolean) => {
  const { isLoading, data, refetch, error } = useQuery<GetItemQueryResponse>(
    `device-${id}`,
    () => getJSON({ url: getItemQuery(id) }),
    {
      enabled: enabled && !!id
    }
  )

  return {
    device: data?.result as Device,
    isLoading,
    refetch,
    error
  }
}

export type GetItemQueryResponse = {
  result?: DeviceItemResponse
}

const getItemQuery = (id?: string) => `/api/list/devices/${id}`

export default useDeviceById
